import {IReg, REG} from "/@lib@/commons/registry.js";
import {JSX, ShadowJsx} from "/@lib@/commons/xml/dom.js";
import {DOMSH} from "/@lib@/commons/xml/domsh.js";
import {BaseElement, OSkinableInit} from "/@back@/commons/basis.js";
import {JWspOptionDef, WSPPACK} from "/@lib@/wsp/pack.js";
import {POPUP, PopupTooltip} from "/@back@/commons/widgets/popups.js";
import {IView} from "/@lib@/commons/views.js";
import {IItemUiEnv} from "/@back@/wsp/views/itemMain.js";
import {STYLER} from "/@lib@/styler/styler.js";


/**
 * Widget d'affichage d'un "skinClass"
 */
export interface OStylerSkinCLassInit extends OSkinableInit {
	skinCLass: string;
}

export class StylerSkinCLass extends BaseElement {
	protected skinCLass: string;

	private titleElt: HTMLDivElement;

	private reg: IReg<IItemUiEnv>;

	protected _initialize(init: OStylerSkinCLassInit) {
		const sr = this.attachShadow(DOMSH.SHADOWDOM_INIT);
		this._initAndInstallSkin(this.localName, init);

		this.reg = this.findReg(init);
		this.skinCLass = init.skinCLass;

		this.titleElt = sr.appendChild(<div/>) as HTMLDivElement;
		/*
		this.addEventListener("click", async ()=>{
			POPUP.showDialog<string | null>(<c-box skin="styler-skinclass/tooltip" >
				<ShadowJsx>
					{await this.makeTooltip()}
				</ShadowJsx>
			</c-box>, this, {titleBar: {barLabel: {label: "Nouveau dossier des favoris"}}, resizer: {}}).onNextClose();
		});
		*/

		POPUP.promiseTooltip(this, async (owner: HTMLElement, tooltip: PopupTooltip): Promise<IView | null> => {
				return <c-box skin="styler-skinclass/tooltip" skinOver="scroll/large">
					<ShadowJsx>
						{await this.makeTooltip()}
					</ShadowJsx>
				</c-box>
			},
			{
				skinOver: 'styler-skinclass/tooltip',
				tooltipOf: this,
				hoverAllowed: true,
				anchor: {
					posFrom: this,
					fromX: 'end',
					marginX: -1,
					notAvailableSpace: {
						posFrom: this,
						fromX: 'start',
						targetX: 'end',
						marginX: 1
					}
				}
			}
		);
		this.refresh();
	}

	protected _refresh() {
		super._refresh();
		const skinClass = STYLER.getSkinClass(this.reg.env.wsp, this.skinCLass);
		this.titleElt.textContent = skinClass ? skinClass.name : this.skinCLass;
	}

	protected async makeTooltip(): Promise<HTMLElement> {
		const returnElt = <div/>;
		const wspTypesDefList = await WSPPACK.listWspTypesDef(this.reg.env.universe.packServer, [this.skinCLass], true);

		returnElt.appendChild(<div>Usages dans les modèles documentaires installés : </div>)
		const mainUlPropsElt_models = returnElt.appendChild(<div class="models"/>);
		if (wspTypesDefList.length > 0) {
			const listModels = mainUlPropsElt_models.appendChild(<ul/>) as HTMLUListElement;
			wspTypesDefList.sort((e1, e2) => {
				if ((e1 as JWspOptionDef).isOption && !(e2 as JWspOptionDef).isOption) return 1;
				if ((e2 as JWspOptionDef).isOption && !(e1 as JWspOptionDef).isOption) return -11;
				return e2.title.localeCompare(e1.title);
			}).forEach((owner) => {
				const skinClassGenerators = owner.generators?.filter((entry) => entry.skinClass === this.skinCLass);
				if (skinClassGenerators?.length > 0) {
					const model = owner.title;
					const ulModelElt = listModels.appendChild(<li class="model"><span class="title">{`Modèle '${model}'`}</span></li>).appendChild(<ul/>);
					skinClassGenerators.sort((e1, e2) => e1.name.localeCompare(e2.name)).forEach((entry) => {
						const gen = entry.name;
						ulModelElt.appendChild(<li>{`Générateur '${gen}'`}</li>);
					});
				}
			});
		} else
			mainUlPropsElt_models.appendChild(<span class="info">aucun</span>);
		return returnElt;
	}
}

REG.reg.registerSkin('styler-skinclass', 1, /* language=CSS */ `
	:host {
		background-color: #9e81bd;
		color: white;
		display: inline-flex;
		min-height: 0;
		min-width: 5em;
		border-radius: 2px 8px 8px 2px;
		margin: 1px;
		padding: 1px 3px 1px 3px;
		cursor: pointer;
		background-image: url("/@skin@/styler/widgets/skinClass.svg");
		background-position: 2px;
		background-size: auto .7em;
		background-repeat: no-repeat;
		padding-inline-start: 1.2em;
		box-shadow: 1px 1px 2px 0px #bbb;
	}

	:host([hidden]) {
		display: none;
	}

`);

REG.reg.registerSkin('styler-skinclass/tooltip', 1, /* language=CSS */ `
	.models {
		font-size: .8em;
		max-height: 20em;
		margin-inline-start: 2em;
		overflow: auto;
	}

	.model {
		margin-top: .3em;
	}

	.model > .title {
		color: var(--alt2-color);
	}

	ul > * > ul {
		padding-inline-start: 1.5rem;
	}

	ul {
		margin-block-start: 0;
		padding-inline-start: 0em;
		list-style-type: none;
		list-style-type: "- ";
	}
`);

customElements.define('styler-skinclass', StylerSkinCLass);

